<script>
  export default {
    name: 't-section',
    props: {
      background: {
        type: String || null,
        default: null,
        required: false
      },
      gap: {
        type: String || null,
        default: null,
        required: false
      }
    },
    render(h) {
      return h(
        'div',
        {
          ref: this.ref,
          class: `${this.background ? this.background : this.theme === 'light' ? 'bg-white' : 'bg-concrete'} p-2 flex flex-col ${
            this.gap ? this.gap : 'gap-4'
          } w-full rounded-md`
        },
        this.$slots.default
      )
    }
  }
</script>
